import { _Componentes_WebApiCalls_Post } from "../ComponentesGlobales/WebApiCalls";

export const obtenerPrecioVenta = ({ EmpresaId, ClienteId, MercaderiaId }, opciones) =>
  _Componentes_WebApiCalls_Post("ListasPrecios/GetPrecioPiSeun", {
    EmpresaId,
    ClienteId: Number(ClienteId) || 0,
    MercaderiaId: Number(MercaderiaId),
  }, opciones);

export const insertarVenta = (request) =>
  _Componentes_WebApiCalls_Post("Api00557/Insert", request, { preservarDatosConError: true });

export const obtenerConsumidorFinal = ({ EmpresaId }, opciones) =>
  _Componentes_WebApiCalls_Post("Api00557/ConsumidorFinal", {
    EmpresaId: Number(EmpresaId) || 0,
  }, opciones);

export const obtenerOpcionesFacturacion = ({
  EmpresaId,
  ClienteId,
  TotalOperacion,
  SolicitaIdentificacionFiscal,
  FacturarComoConsumidorFinal,
}, opciones) =>
  _Componentes_WebApiCalls_Post("Api00557/FacturacionOpciones", {
    EmpresaId: Number(EmpresaId) || 0,
    ClienteId: Number(ClienteId) || 0,
    TotalOperacion: Number(TotalOperacion) || 0,
    SolicitaIdentificacionFiscal: Boolean(SolicitaIdentificacionFiscal),
    FacturarComoConsumidorFinal: Boolean(FacturarComoConsumidorFinal),
  }, opciones);

export const obtenerTiposDocumentoCliente = ({ EmpresaId }, opciones) =>
  _Componentes_WebApiCalls_Post("Combos/TiposDocumentos", { EmpresaId }, opciones);

export const obtenerCondicionesIvaCliente = ({ EmpresaId }, opciones) =>
  _Componentes_WebApiCalls_Post("Combos/CondicionesIVA", { EmpresaId }, opciones);

export const insertarClienteVenta = ({ EmpresaId, cliente, OperadorId = 0, PcId = 0 }, opciones) => {
  const clienteSinCodigo = { ...cliente };
  delete clienteSinCodigo.sCodigo;
  delete clienteSinCodigo.Codigo;

  return _Componentes_WebApiCalls_Post("Clientes/Insert", {
    EmpresaId,
    oCliente: clienteSinCodigo,
    OperadorId: Number(OperadorId) || 0,
    PcId: Number(PcId) || 0,
  }, opciones);
};

export const obtenerDocumentoVenta = ({ EmpresaId, VentaId }) =>
  _Componentes_WebApiCalls_Post("Api00557/Documento", { EmpresaId, VentaId: Number(VentaId) });

export const obtenerPagosVenta = ({ EmpresaId, VentaId }) =>
  _Componentes_WebApiCalls_Post("Api00557/Pagos", { EmpresaId, VentaId: Number(VentaId) });

export const obtenerUltimasVentas = ({
  EmpresaId,
  CajaSesionId = 0,
  OperadorId = null,
  Cantidad = 10,
}, opciones) =>
  _Componentes_WebApiCalls_Post("Api00557/UltimasVentas", {
    EmpresaId: Number(EmpresaId) || 0,
    CajaSesionId: Number(CajaSesionId) || 0,
    OperadorId: OperadorId == null ? null : Number(OperadorId) || null,
    Cantidad: Math.min(50, Math.max(1, Number(Cantidad) || 10)),
  }, opciones);

export const normalizarUltimaVenta = (venta = {}) => {
  const total = Number(venta.Total ?? venta.total) || 0;
  return {
    VentaId: Number(venta.VentaId ?? venta.ventaId) || 0,
    CajaSesionId: Number(venta.CajaSesionId ?? venta.cajaSesionId) || 0,
    dFecha: venta.Fecha ?? venta.fecha ?? null,
    Cliente_Id: Number(venta.ClienteId ?? venta.clienteId) || 0,
    ClienteDescripcion: String(venta.Cliente ?? venta.cliente ?? ""),
    Operador_Id: Number(venta.OperadorId ?? venta.operadorId) || 0,
    OperadorDescripcion: String(venta.Operador ?? venta.operador ?? ""),
    FormaPago: String(venta.FormaPago ?? venta.formaPago ?? ""),
    oResumen: {
      SubtotalBruto: Number(venta.SubtotalBruto ?? venta.subtotalBruto) || 0,
      DescuentoTotal: Number(venta.DescuentoTotal ?? venta.descuentoTotal) || 0,
      Total: total,
      TotalConIva: total,
    },
    CantidadLineas: Number(venta.CantidadLineas ?? venta.cantidadLineas) || 0,
    Unidades: Number(venta.Unidades ?? venta.unidades) || 0,
    EstadoVenta: String(venta.EstadoVenta ?? venta.estadoVenta ?? ""),
    RemitoId: Number(venta.RemitoId ?? venta.remitoId) || 0,
    RemitoNumero: String(venta.RemitoNumero ?? venta.remitoNumero ?? ""),
    FacturaId: Number(venta.FacturaId ?? venta.facturaId) || 0,
    lstDetalle: [],
    DesdeBaseDatos: true,
  };
};

export const extraerUltimasVentas = (respuesta = {}) => {
  const lista = respuesta.Lista ?? respuesta.lista ?? [];
  return Array.isArray(lista) ? lista.map(normalizarUltimaVenta) : [];
};
